export const handleChangeDataUserAddresses = (name, value) => ({
    type: 'CHANGE_DATA_USER_ADDRESSES', name, value
});